module.exports = __webpack_public_path__ + "static/media/EK.6d830bd2.png";